const React = require("react");
const T = require("prop-types");
const FlatButton = require("material-ui/FlatButton").default;
const RaisedButton = require("material-ui/RaisedButton").default;
const Classes = require("./styles.scss");
const DownloadIcon = require("material-ui/svg-icons/file/file-download")
    .default;
const StarIcon = require("material-ui/svg-icons/action/grade").default;
const DownloadDialog = require("containers/DownloadDialog");
const TransactionDialog = require("containers/TransactionDialog");
const NavLink = require("react-router-dom").NavLink;
const { previewImageLink } = require("utils/asset-api");
const ContentHelpers = require("utils/content-helpers");

const internals = {};

internals.renderDate = dateString => {
    const date = new Date(dateString);

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    return month + "/" + day + "/" + year;
};

internals.labelStyle = {
    textTransform: "inherit"
};

module.exports = class PurchasedBodyModelView extends React.Component {
    static propTypes = {
        token: T.string.isRequired,
        fetchData: T.func.isRequired,
        onDownloadOptionsClick: T.func.isRequired,
        croquis: T.shape({
            id: T.number.isRequired,
            title: T.string.isRequired,
            dateCreated: T.string.isRequired,
            measurements: T.object.isRequired,
            downloadPackage: T.shape({
                name: T.oneOf(["basic", "premium"]).isRequired
            }).isRequired
        }).isRequired,
        match: T.object,
        onUpgradeClick: T.func.isRequired
    };

    componentDidMount() {
        const { croquis, fetchData } = this.props;

        window.scrollTo(0, 0);

        if (typeof croquis === "undefined") {
            fetchData(this.props.match.params.id);
        }
    }

    renderDownloadOptions() {
        const { croquis, onDownloadOptionsClick } = this.props;
        const { downloadPackage } = croquis;

        return (
            <div className={Classes.buttonGroup}>
                <RaisedButton
                    label={`Download ${ContentHelpers.capitalize(
                        downloadPackage.name
                    )}`}
                    icon={<DownloadIcon />}
                    labelStyle={internals.labelStyle}
                    onClick={() => onDownloadOptionsClick(croquis.id)}
                />
            </div>
        );
    }

    render() {
        const { croquis, onUpgradeClick } = this.props;

        if (typeof croquis === "undefined") {
            return <div>No Body Model found.</div>;
        }

        const { downloadPackage } = croquis;

        return (
            <div>
                <form
                    className={Classes.croquisRender}
                    onSubmit={this.handleSubmit}
                >
                    <h1>Your Purchased Files</h1>
                    <h2>
                        {downloadPackage.name === "premium" && (
                            <StarIcon style={{ verticalAlign: "middle" }} />
                        )}{" "}
                        {croquis.title}
                    </h2>
                    <p>
                        Purchased: {internals.renderDate(croquis.dateCreated)}
                    </p>
                    {downloadPackage.name === "basic" && (
                        <RaisedButton
                            primary
                            label={
                                <span>
                                    <StarIcon
                                        color="white"
                                        style={{
                                            position: "relative",
                                            top: ".6rem",
                                            right: ".5rem"
                                        }}
                                    />
                                    Upgrade to Premium (1 Credit)
                                </span>
                            }
                            onClick={() => onUpgradeClick(croquis.id)}
                            labelStyle={internals.labelStyle}
                        />
                    )}
                    <div
                        className={Classes.croquisContainer}
                        style={{
                            backgroundImage: `url(${previewImageLink(
                                croquis,
                                "purchase",
                                this.props.token
                            )})`
                        }}
                    />
                    <hr />
                    <div className={Classes.buttonContainer}>
                        {this.renderDownloadOptions()}
                        <div className={Classes.buttonGroup}>
                            <FlatButton
                                primary
                                label="Go to Portfolio"
                                labelStyle={internals.labelStyle}
                                containerElement={<NavLink to="/portfolio" />}
                            />
                        </div>
                    </div>
                </form>
                <hr />
                <div className={Classes.betaBanner}>
                    <p>
                        MyBodyModel is a new app.
                        If something isn't working correctly, please let us know!
                    </p>
                    <p>
                        Email{" "}
                        <a href="mailto:help@mybodymodel.com">
                            help@mybodymodel.com
                        </a>{" "}
                        with a detailed description, including a screenshot if
                        possible. Thank you!
                    </p>
                </div>
                <DownloadDialog
                    onUpgradeClick={modelId => onUpgradeClick(modelId)}
                />
                <TransactionDialog />
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/purchased-body-model-view/components/PurchasedBodyModelView.js